"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'akash',
    client_id: '07-tendermint-183',
    connection_id: 'connection-171'
  },
  chain_2: {
    chain_name: 'doravota',
    client_id: '07-tendermint-17',
    connection_id: 'connection-11'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-125',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'archway',
    client_id: '07-tendermint-66',
    connection_id: 'connection-72'
  },
  chain_2: {
    chain_name: 'doravota',
    client_id: '07-tendermint-20',
    connection_id: 'connection-24'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-101',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'coreum',
    client_id: '07-tendermint-12',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'doravota',
    client_id: '07-tendermint-12',
    connection_id: 'connection-4'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cosmoshub',
    client_id: '07-tendermint-1191',
    connection_id: 'connection-920'
  },
  chain_2: {
    chain_name: 'doravota',
    client_id: '07-tendermint-14',
    connection_id: 'connection-8'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-750',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-16',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'dydx',
    client_id: '07-tendermint-15',
    connection_id: 'connection-21'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-15',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-15',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'injective',
    client_id: '07-tendermint-245',
    connection_id: 'connection-239'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-182',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-13',
    connection_id: 'connection-5'
  },
  chain_2: {
    chain_name: 'nolus',
    client_id: '07-tendermint-14',
    connection_id: 'connection-12'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4092',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-0',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2959',
    connection_id: 'connection-2454'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2694',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-21',
    connection_id: 'connection-27'
  },
  chain_2: {
    chain_name: 'sei',
    client_id: '07-tendermint-109',
    connection_id: 'connection-153'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-12',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-64',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;